import { Component, OnInit } from '@angular/core';

import { CatalogComponent } from '../../../../modals/catalog/catalog.component';
import { MarketingService } from '../../../../../shared/_services/marketing.service';
import { HcaUserManagementService } from '../../../../../shared/_services/hca-user-management.service';
import { UtilService } from '../../../../../shared/_services/util.service';
import { StatusModalComponent } from '../../../../modals/status-modal/status-modal.component';
import { BsModalRef, BsModalService } from 'ngx-bootstrap/modal';
import { ActivatedRoute, Router } from '@angular/router';
import { Subject } from 'rxjs';

@Component({
  selector: 'app-rewards-catalog',
  templateUrl: './rewards-catalog.component.html',
  styleUrls: ['./rewards-catalog.component.scss'],
})
export class RewardsCatalogComponent implements OnInit {
  products: any;
  selectedProduct: any = "";
  selectedStatus: any = "";
  brandHotels: any;
  filterDefault: boolean = false;
  loading: boolean = false;
  filterSvg = 'assets/images/filter-inactive.svg';
  actionSvg = 'assets/images/action-inactive.svg';
  hotelBrands: any;
  searchText: string;
  statusModal: BsModalRef;
  allBrandsSelected: boolean = true;
  allRewardsSelected: boolean = false;
  allHotelsSelected: any = true;
  selectedBrands: any[] = [];
  selectedHotels: any[] = [];
  selectedRewards: any[] = [];
  catalogs: any[] = [];
  rewards: any[] = [];
  selectedCatalog: any = {
    catalogId: 0,
    catalogName: 'Rewards Catalog (All)'
  };
  private active: boolean = false;
  filteredOptions: any = {
    "hotelChainId": null,
    "productId": null,
    "statusId": null,
    "hotels": [],
    "pageNumber": 0,
    "catalogId": null
  }
  bsModalRef: BsModalRef;
  private unsubscribe: Subject<void> = new Subject<void>();

  constructor(
    private modalService: BsModalService,
    private marketingService: MarketingService,
    private utilService: UtilService,
    private hcaUserManagementService: HcaUserManagementService,
    private router: Router
  ) {
    document.addEventListener('click', this.offClickHandler.bind(this));

    this.modalService.onHide
      .takeUntil(this.unsubscribe).subscribe(res => {
        if (this.statusModal) {
          if (this.statusModal.content.srcObject.action == "action1") {
            if (this.statusModal.content.srcObject.type == "reward-list") {
              let statusId: any;
              let status: string;
              if (this.statusModal.content.srcObject.status === 'Activate') {
                statusId = 1;
                status = "Active";
              } else {
                statusId = 0;
                status = "Inactive";
              }
              this.marketingService.activateOrDeactivateRewardCatalog(this.statusModal.content.srcObject.id, statusId).subscribe(
                res => {
                  if (!this.statusModal.content.srcObject.form || this.statusModal.content.srcObject.form == "") {
                    this.getCatalogsList();
                  }
                  else {
                    this.statusModal.content.srcObject.form.status = status;
                  }
                }, error => {
                  console.error(error);
                });
            }
            if (this.statusModal.content.srcObject.type == "catalog") {
              this.marketingService.activateOrDeactivateCatalog(this.statusModal.content.srcObject.id, this.statusModal.content.srcObject.status).subscribe(res => {
                if (res.error == 0) {
                  this.getCatalogsList();
                  // if(this.statusModal.content.srcObject.form == ""){
                  //   this.getCatalogsList();
                  // }
                  // else{
                  //   this.statusModal.content.srcObject.form.status = status;
                  // }
                } else {
                  //   this.errorDetails = res.message;
                }
              })
            }
          }
        } else {
          this.getCatalogsList();
        }
      })
  }

  ngOnInit() {
    this.getCatalogsList();
    this.getRewardPorductTypes();
    this.selectedCatalog = {
      catalogId: 0,
      catalogName: 'Rewards Catalog (All)'
    };
  }

  offClickHandler(event: any) {
    if (!event.target.closest(".filter") && !event.target.closest(".filter")) {
      // do whatever you want here
      if (document.getElementById('ul')) {
        document.getElementById('ul').style.display = 'none';
      }
    }
  }
  getHotelBrandsByHotelChain() {
    this.hcaUserManagementService.getHotelBrandsByHotelChain().subscribe(
      res => {
        if (res.error == 0) {
          this.hotelBrands = res.responseObj;
          this.selectAll('brand');
        }
        else {
          console.error("Get Hotel Brands : " + res.message);
        }
      }, err => {
        console.error(err);
      });
  }

  getRewardPorductTypes() {
    this.marketingService.getRewardProductTypes().subscribe(res => {
      if (res.error == 0) {
        this.products = res.responseObj;
      }
    })
  }

  getCatalogsList() {
    this.loading = true;
    this.marketingService.getCatalogs("false").subscribe(res => {
      this.loading = false;
      if (res.error == 0) {
        if (res.responseObj.length) {
          this.catalogs = res.responseObj;
          this.getHotelBrandsByHotelChain();
          if (this.selectedCatalog && this.selectedCatalog.catalogId > 0) {
            this.catalogs.forEach(catalog => {
              if (this.selectedCatalog.catalogId == catalog.catalogId) {
                this.selectedCatalog = catalog;
                this.filteredOptions.catalogId = catalog.catalogId == 0 ? null : parseInt(catalog.catalogId);
                this.getRewardsList(this.filteredOptions);
              };
            })
          }
          else {
            this.selectedCatalog = { catalogId: 0, catalogName: 'Rewards Catalog (All)' };
            this.filteredOptions.catalogId = this.selectedCatalog.catalogId == 0 ? null : parseInt(this.selectedCatalog.catalogId);
            this.getRewardsList(this.filteredOptions);
          }
        }
        //this.selectedCatalog = res.responseObj[0];
      }
    })
  }


  getHotelsList() {
    let brandIds = this.utilService.cleanArray(this.selectedBrands);
    //let hotelIds = this.utilService.cleanArray(this.selectedHotels);
    this.hcaUserManagementService.getHotelsByBrand(brandIds).subscribe(
      res => {
        if (res.error == 0) {
          this.brandHotels = res.responseObj;
          this.selectAll('hotel');
        }
        else {
          this.brandHotels = [];
          this.selectedHotels = [];
          setTimeout(() => {
            this.selectAll('hotel');
          }, 100);
        }
      }, err => {
        this.brandHotels = [];
        this.selectedHotels = [];
        setTimeout(() => {
          this.selectAll('hotel');
        }, 100);
        // console.error(err);
      });
  }

  filterChanged() {
    //let filteredOptions: any = {};
    this.filteredOptions.statusId = this.selectedStatus ? parseInt(this.selectedStatus) : null;
    this.filteredOptions.productId = this.selectedProduct ? parseInt(this.selectedProduct) : null;
    this.filteredOptions.catalogId = this.selectedCatalog.catalogId == 0 ? null : parseInt(this.selectedCatalog.catalogId);
    this.filteredOptions.pageNumber = 0;
    this.filteredOptions.hotelChainId = null;
    // this.filteredOptions.hotels = this.allBrandsSelected ? [] : this.selectedHotels;
    // this.filteredOptions.brands = this.selectedBrands;
    this.filteredOptions.hotels = this.allBrandsSelected && this.allHotelsSelected ? [] : (this.selectedHotels.length == 0 ? null : this.selectedHotels);
    if (this.filteredOptions.statusId != null || this.filteredOptions.productId != null || !this.allBrandsSelected || !this.allHotelsSelected) {
      this.filterDefault = true;
      this.filterSvg = 'assets/images/filter-active.svg';
    } else {
      this.filterDefault = false;
      this.filterSvg = 'assets/images/filter-inactive.svg';
    }
    this.getRewardsList(this.filteredOptions);
  }


  selectAll(type) {
    if (type == 'brand') {
      for (var i = 0; i < this.hotelBrands.length; i++) {
        this.hotelBrands[i].checked = this.allBrandsSelected;
      }
      this.selectedBrands = this.utilService.cleanArray(this.hotelBrands.map(brand => {
        if (brand.checked) {
          return brand.brandId;
        }
      }))
      // if (!this.allBrandsSelected) {
      this.getHotelsList();
      // }
      this.filterChanged();
    } else if (type == 'hotel') {
      for (var i = 0; i < this.brandHotels.length; i++) {
        this.brandHotels[i].checked = this.allHotelsSelected;
      }
      this.selectedHotels = this.utilService.cleanArray(this.brandHotels.map(hotel => {
        if (hotel.checked) {
          return hotel.hotelId
        }
      }))
      this.filterChanged();
    } else if (type == 'reward') {
      for (var i = 0; i < this.rewards.length; i++) {
        this.rewards[i].checked = this.allRewardsSelected;
      }
      this.selectedRewards = this.utilService.cleanArray(this.rewards.map(reward => {
        if (reward.checked) {
          this.actionSvg = 'assets/images/action-active.svg';
          return reward.rewardId

        } else {
          this.actionSvg = 'assets/images/action-inactive.svg';
        }

      }))
    }
    // this.filterChanged();

  }

  checkSelection(type) {
    if (type == 'brand') {
      this.allBrandsSelected = this.hotelBrands.every(function (item: any) {
        return item.checked == true;
      })
      this.selectedBrands = this.utilService.cleanArray(this.hotelBrands.map(brand => {
        if (brand.checked) {
          return brand.brandId
        }
      }))
      // if (!this.allBrandsSelected) {
      this.getHotelsList();
      // }
      this.filterChanged();
    } else if (type == 'hotel') {
      this.allHotelsSelected = this.brandHotels.every(function (item: any) {
        return item.checked == true;
      })
      this.selectedHotels = this.utilService.cleanArray(this.brandHotels.map(hotel => {
        if (hotel.checked) {
          return hotel.hotelId
        }
      }))
      this.filterChanged();
    } else if (type == 'reward') {
      this.allRewardsSelected = this.rewards.every(function (item: any) {
        return item.checked == true;
      })
      this.selectedRewards = this.utilService.cleanArray(this.rewards.map(reward => {
        if (reward.checked) {
          this.actionSvg = 'assets/images/action-active.svg';
          return reward.rewardId
        } else if (this.selectedRewards.length > 0) {
          this.actionSvg = 'assets/images/action-active.svg';

        }
      }))
    }
    // this.filterChanged();
  }

  SelectAllRewards(type) {
    if (type == 'Active') {
      this.openModalActivateDeactivate(this.selectedRewards, 'Active', "");
    } else if (type == 'Inactive') {
      this.openModalActivateDeactivate(this.selectedRewards, 'Inactive', "");
    }
  }

  templateString(type, info) {
    return `${info} ${type}${info == 1 ? '' : 's'} selected`;
  }

  getRewardsList(options) {
    this.loading = true;
    this.marketingService.getRewards(options).subscribe(res => {
      this.loading = false;
      if (res.error == 0) {
        if (res.responseObj && res.responseObj.length) {
          this.rewards = res.responseObj;
          this.allRewardsSelected = false;
          this.selectedRewards = [];
        } else {
          this.rewards = [];
          this.allRewardsSelected = false;
          this.selectedRewards = [];
        }
      }
    }, err => {
      this.rewards = [];
      this.allRewardsSelected = false;
      this.selectedRewards = [];
    })
  }

  changeCatalogStatus(status) {
    this.statusModal = this.modalService.show(StatusModalComponent, { class: 'confirm-modal' });
    this.statusModal.content.srcObject = {
      mode: "custom",
      type: 'catalog',
      title: `${status == 'Activate' ? 'Activate' : 'Deactivate'}`,
      message: `Are you sure you want to ${status == 'Activate' ? 'activate' : 'deactivate'} this catalog?`,
      status: status,
      id: this.selectedCatalog.catalogId,
      action1: `${status == 'Activate' ? 'Activate' : 'Deactivate'}`,
      action2: 'Cancel',
      action: '',
      style: `${status == 'Activate' ? 'active' : 'inactive'}`,
    }
  }

  getRewardsByCatalog(catalog) {
    this.selectedCatalog = catalog;
    // TODO - get rewards for selected catalog.
    this.selectedBrands = [];
    this.selectedHotels = [];
    this.selectedStatus = "";
    this.selectedProduct = "";
    this.filterDefault = false;
    this.allBrandsSelected = true;
    this.allHotelsSelected = true;
    this.selectAll('brand');
    this.selectAll('hotel');
    this.filteredOptions = {
      "hotelChainId": null,
      "productId": "",
      "statusId": "",
      "hotels": [],
      "pageNumber": 0,
      "catalogId": catalog.catalogId == 0 ? null : parseInt(catalog.catalogId)
    }
    // this.filteredOptions.catalogId = catalog.catalogId == 0 ? null : parseInt(catalog.catalogId);
    this.getRewardsList(this.filteredOptions);
  }

  openModalActivateDeactivate(id, mode, reward) {
    this.statusModal = this.modalService.show(StatusModalComponent, { class: 'confirm-modal' });
    let message = "";
    let title = "";
    let action1 = "";
    let style = "";
    let status = "";
    if (mode == 'Active') {
      message = "Are you sure you want to deactivate reward(s)?";
      title = "Deactivate Reward";
      action1 = "Deactivate";
      style = "inactive";
      status = "Inactive";
    }
    else if (mode == 'Inactive') {
      message = "Are you sure you want to activate reward(s)?";
      title = "Activate Reward";
      action1 = "Activate";
      style = "active";
      status = "Activate";
    }
    this.statusModal.content.srcObject = {
      mode: "custom",
      type: 'reward-list',
      title: title,
      message: message,
      status,
      id: id,
      action1: action1,
      action2: 'Cancel',
      action: '',
      style: style,
      form: reward
    }
  }


  catalogModal(id?) {
    this.bsModalRef = this.modalService.show(CatalogComponent);
    if (id) {
      this.bsModalRef.content.catalogId = id;
    }
  }

  dropDown(e) {

    if (document.getElementById('ul').style.display == 'block') {
      document.getElementById('ul').style.display = 'none';
    } else {
      document.getElementById('ul').style.display = 'block';
    }
  }
  stopPropagation(e) {
    // e.currentTarget.style.display = 'block';
    e.stopPropagation();
  }
  ngOnDestroy() {
    this.unsubscribe.next();
    this.unsubscribe.complete();
  }
}



// WEBPACK FOOTER //
// ./src/app/components/admin/hca-admin/marketing/rewards-catalog/rewards-catalog.component.ts